import React from 'react';
import './add subCategory.css'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon } from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { hasValue } from "../../validations/validations";
import { message, TreeSelect } from "antd";
const { TreeNode } = TreeSelect;
class AddSubCategory extends React.Component {
  state = {
    categoryName_en: '',
    categoryName_ar: '',
    description_en: '',
    description_ar: '',
    redfKey: '',
    categories: [],
    parent: this.props.location.state ? this.props.location.state.data : []
  };

  constructor(props) {
    super(props)
    console.log(this.props.location.state.data)
    window.scrollTo(0, 0)
    this.getCategory()
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }
  componentDidMount() {
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }

  getCategory = () => {
    axios.get(`${BASE_END_POINT}categories`)
      .then(response => {
        console.log(response.data)
        this.setState({ categories: response.data.data })
      })
      .catch(error => {
        console.log("ALL categories ERROR")
        console.log(error.response)
      })
  }
  addSubCategory = () => {
    const { categoryName_ar, categoryName_en, parent, redfKey, description_ar, description_en } = this.state
    let l = message.loading('Wait..', 1.5)

    if (parent.length > 0) {
      l.then(() => message.success(allStrings.completeData, 0.5))
    }
    if (hasValue(categoryName_ar) && hasValue(categoryName_en)) {

      let data = new FormData()
      data.append('categoryName_ar', categoryName_ar)
      data.append('categoryName_en', categoryName_en)
      data.append('description_ar', description_ar)
      data.append('description_en', description_en)
      data.append('parent', parent)
      data.append('redfKey', redfKey)
      axios.post(`${BASE_END_POINT}categories`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${this.props.currentUser.token}`,
          'Accept-Language': this.props.isRTL ? 'ar' : 'en'
        },
      })
        .then(response => {
          console.log("USER UPDATED  ", response.data)
          l.then(() => message.success(allStrings.done, 2.5))
          this.props.history.goBack()
        })
        .catch(error => {
          console.log(error.response)
          l.then(() => message.error(allStrings.error, 2.5))
        })
    }
  }


  submitHandler = event => {
    event.preventDefault();
    event.target.className += " was-validated";
    this.addSubCategory()
  };

  changeHandler = event => {
    this.setState({ [event.target.name]: event.target.value });
  };




  render() {
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('CATEGORIES')) return <Redirect to='/Home' />

    return (
      <div className="App">

        <MDBContainer>
          <MDBRow>
            <MDBCol xl="12" lg="12" md="12" sm="12">
              <div className="infoCard">
                <Card className="editCard" style={{ overflow: 'visible', outline: 'none', marginBottom: '0px' }}>
                  <CardMedia
                    style={{ height: "0px" }}
                  />
                  <CardHeader></CardHeader>
                  <div style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row', display: 'flex' }}>
                    <div className="topIcon" style={{ background: 'linear-gradient(135deg, #1D9598, #127275)' }}>
                      <span className="material-icons" style={{ color: 'white', fontSize: 23 }}>category</span>
                    </div>
                    <div className="tableTitle" style={{
                      display: 'inline-block', marginTop: '-60px',
                      marginLeft: '0', marginRight: '0'
                    }}>
                      <p>{allStrings.addSubCategory}</p>
                    </div>
                  </div>
                  <CardContent style={{ minHeight: "390px", outline: 'none' }}>
                    <MDBContainer>
                      <MDBRow>
                        <MDBCol md="12">
                          <form
                            className="needs-validation"
                            onSubmit={this.submitHandler}
                            noValidate
                          >

                            <div className="grey-text">
                              <MDBRow>
                                <MDBCol md="6">
                                  <div className="md-form">
                                    <label htmlFor="form3" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.englishName}</label>
                                    <input onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9-,.@%$؟'"?#*&()_^&!\\/\s-_]/g, '')} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={this.state.categoryName_en} type="text" id="form3" name="categoryName_en" className="form-control" onChange={this.changeHandler} required validate placeholder="أدخل اسم التصنيف بالانجليزية..." />
                                    <div class="valid-feedback">{allStrings.correct}</div>
                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                  </div>
                                </MDBCol>

                                <MDBCol md="6">
                                  <div className="md-form">
                                    <label htmlFor="form3" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.arabicName}</label>
                                    <input onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^\u0600-\u06FF0-9\u0660-\u0669#.,@?؟%$_^*()/\\ _-]+/g, '')} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={this.state.categoryName_ar} type="text" id="form2" name="categoryName_ar" className="form-control" onChange={this.changeHandler} required validate placeholder="أدخل اسم التصنيف بالعربية..." />
                                    <div class="valid-feedback">{allStrings.correct}</div>
                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                  </div>
                                </MDBCol>
                              </MDBRow>
                              <MDBRow>
                                <MDBCol md="12">
                                  <div className="md-form">
                                    <label htmlFor="form920" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.englishDescription}</label>
                                    <br></br>
                                    <textarea disabled={this.state.actionType === "VIEW" ? true : false} onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9-,.@%$؟'"?#*&()_^&!\\/\s-_]/g, '')} name="description_en" onChange={this.changeHandler} value={this.state.description_en} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="text" id="form920" className="form-control" validate placeholder="أدخل الوصف بالانجليزية..." />
                                    <div class="valid-feedback">{allStrings.correct}</div>
                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                  </div>
                                </MDBCol>

                              </MDBRow>
                              <MDBRow>
                                <MDBCol md="12">
                                  <div className="md-form">
                                    <label htmlFor="form920" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.arabicDescription}</label>
                                    <br></br>
                                    <textarea disabled={this.state.actionType === "VIEW" ? true : false} onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^\u0600-\u06FF0-9\u0660-\u0669#.,@?؟%$_^*()/\\ _-]+/g, '')} name="description_ar" onChange={this.changeHandler} value={this.state.description_ar} style={{ border: 'none', borderBottom: '1px solid #dededede', direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center', padding: '.3rem 7px .4rem 7px' }} type="text" id="form920" className="form-control" validate placeholder="أدخل الوصف بالعربية..." />
                                    <div class="valid-feedback">{allStrings.correct}</div>
                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                  </div>
                                </MDBCol>
                              </MDBRow>
                              <MDBRow>
                                <MDBCol md="6">
                                  <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.redfCategory}</label>
                                  <TreeSelect virtual={false}
                                    showSearch={true}
                                    style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                    treeCheckable={false}
                                    treeNodeFilterProp="title"
                                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                    placeholder={allStrings.redfCategory}
                                    onChange={(value) => {
                                      console.log(value)
                                      this.setState({ redfKey: value });
                                    }}

                                  >

                                    <TreeNode value="Villa" title={allStrings.villa} key="Villa" />
                                    <TreeNode value="Apartment" title={allStrings.apartment} key="Apartment" />
                                    <TreeNode value="Townhouse" title={allStrings.townhouse} key="Townhouse" />
                                    <TreeNode value="Land" title={allStrings.lands} key="Land" />

                                  </TreeSelect>
                                </MDBCol>
                                <MDBCol md="6">
                                  <label className="customLabel" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.category}</label>
                                  <TreeSelect virtual={false}
                                    value={this.state.parent}
                                    showSearch={true}
                                    style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', minHeight: '35px', marginBottom: '1rem' }}
                                    treeCheckable={false}
                                    treeNodeFilterProp="title"
                                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                    placeholder={allStrings.chooseCategory}
                                    onChange={(value) => {
                                      this.setState({ parent: value });
                                      console.log(value)

                                    }}
                                  >
                                    {this.state.categories.map(val => (
                                      <TreeNode value={val.id} title={this.props.isRTL ? val.categoryName_ar : val.categoryName_en} key={val.id} />
                                    ))}
                                  </TreeSelect>
                                </MDBCol>
                              </MDBRow>
                            </div>
                            <br></br>
                            <br></br>
                            <div className="text-center">
                              <MDBBtn
                                style={{ background: 'linear-gradient(135deg, #1D9598, #127275)', color: '#fff' }}
                                rounded
                                type="submit"
                                className="btn-block z-depth-1a"
                              >
                                <MDBIcon icon="plus" className="mr-2" />
                                {allStrings.addSubCategory}
                              </MDBBtn>


                            </div>
                          </form>
                        </MDBCol>

                      </MDBRow>
                    </MDBContainer>
                  </CardContent>
                </Card>
              </div>
            </MDBCol>
          </MDBRow>


        </MDBContainer>

      </div>
    )
  }
}



const mapToStateProps = (state) => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
});

const mapDispatchToProps = {
};

export default withRouter(
  connect(mapToStateProps, mapDispatchToProps)(AddSubCategory)
);